import React, { useEffect, useState, Suspense } from 'react';
import { useThree } from '@react-three/fiber';
import { Text } from '@react-three/drei';

import { useProgress } from './useProgress';
import { ASSET_PATH } from './config';

/*
 * Loading text animation which attaches itself as a child of
 * the camera 0.5 meters in front of the user
 */
export function Loader() {
  const camera = useThree(s => s.camera);
  const { progress } = useProgress();

  const [text, setText] = useState();

  // Move text mesh to be child of camera
  useEffect(() => {
    if (!text || !camera) return;
    camera.add(text);
    return () => text.removeFromParent();
  }, [text, camera]);

  return (
    <Suspense fallback={null}>
      {/* Wrap in suspense to prevent loader from suspending XR provider */}
      <Text
        ref={setText}
        fontSize={0.02}
        textAlign="center"
        position-z={-0.5}
        font={ASSET_PATH + 'fonts/ConcretteSTRIAL-Bold.woff'}>
        Loading {Number(progress).toFixed(0)}%
      </Text>
    </Suspense>
  );
}
